<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-sitemap-outline
      </v-icon> Partners List
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="showAddPartnerForm = true"
        >
          <v-icon
            left
            dark
          >
            mdi-plus
          </v-icon>
          Add New
        </v-btn>
      </v-col>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="partnersList"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>{{ item.base_url }}</td>
            <td>{{ item.app_module.name | appNameUpdate }}</td>
            <td>{{ item.created_at | convertToLocal }}</td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click.stop
                @click="showPartnerApiList(item.id)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#C62828"
                @click="deletePartner()"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
    <add-new-partner
      v-if="showAddPartnerForm"
      @partner-sucess="getPartnersList"
      @closed="showAddPartnerForm = false"
    />
  </v-container>
</template>

<script>
  import moment from 'moment';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';
  import AddNewPartner from './AddNewPartner.vue';

  export default {
    name: 'PartnersList',
    components: {
      'centre-spinner': spinner,
      'add-new-partner': AddNewPartner,
    },
    filters: {
      convertToLocal (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      appNameUpdate (name) {
        if (name === 'digital-signage') {
          return 'Digital Signage';
        } else if (name === 'swift-check-in') {
          return 'Swift Check-In';
        } else if (name === 'swift-check-in-projects') {
          return 'Swift Check-In Projects';
        } else {
          return 'N/A';
        }
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Name', align: 'start', value: 'name' },
          { text: 'Base Url', value: 'base_url' },
          { text: 'App Module', value: 'app_module' },
          { text: 'Added On', value: 'created_at' },
          { text: 'APIs', value: 'api' },
          { text: 'Delete', value: 'delete' },
        ],
        showAddPartnerForm: false,
      };
    },
    computed: {
      partnersList () {
        const list = this.$store.getters['partners/getPartnersList'];
        const sortedList = list.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        return sortedList;
      },
    },
    async mounted () {
      await this.getPartnersList();
    },
    methods: {
      async getPartnersList () {
        this.loading = true;
        await this.$store.dispatch('partners/fetchPartnersList');
        this.loading = false;
      },
      deletePartner () {
        this.$store.dispatch('alert/onAlert', {
          message: 'You are not authorized to perform this action, please contact your administrator.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      },
      showPartnerApiList (id) {
        this.$router.push(`partners/${id}/api`);
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
.v-data-table { background-color: #ECEFF1; }
</style>
